import { render, staticRenderFns } from "./bill-of-materials.vue?vue&type=template&id=55fd9a6a"
import script from "./bill-of-materials.vue?vue&type=script&lang=js"
export * from "./bill-of-materials.vue?vue&type=script&lang=js"
import style0 from "./bill-of-materials.vue?vue&type=style&index=0&id=55fd9a6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports